import { Card, CardBody, Col } from "reactstrap";
import FormCard from "./FormCard";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ValidationFormTitle } from "../../../../../../Constants/Constants";
import { ValidationFormSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";

const ValidationForm = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ValidationFormTitle} span={ValidationFormSubTitle} />
        <CardBody>
          <FormCard />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ValidationForm;
